import React, { useState, useEffect, useContext } from 'react'
// import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { getAllActivitys, createActivity, deleteActivity, editActivity } from '../../../axios/requests/activityReq';
import { useTranslation } from "react-i18next";
import styles from './ActivityContact.module.css';
import { formatDateFromDB } from '../../../util/functions';
import ActivityModal from './ActivityModal';
import AlertContext from '../../../context/AlertModelContext/AlertModalContext';
// import PaginationComponent from '../../UI/Pagination/PaginationComponent';
import { itemsPerPagePagination } from '../../../settings'
import Grid from '../../UI/Grid/Grid';

const ActivityContact = (props) => {
    const alertCtx = useContext(AlertContext)
    const [t] = useTranslation('common')
    const [activities, setActivities] = useState([]);
    const [showActivityModal, setActivitiyShowModal] = useState(false);
    const [newActivity, setNewActivity] = useState({
        activityName: '',
        subject: '',
        remarks: '',
        date: new Date(),
        remaindTimeMin: 0
    });
    const [refreshActivities, setRefreshActivities] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false)

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(itemsPerPagePagination || 9);

    // Calculate the current activities to display
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentActivities = activities.slice(indexOfFirstItem, indexOfLastItem);

    // Change page function
    const paginate = pageNumber => setCurrentPage(pageNumber);

    const headers = [
        { label: t('Activity Name'), className: 'activityName' },
        { label: t('Activity Subject'), className: 'activitySubject' },
        { label: t('Activity Remarks'), className: 'activityRemarks' },
        { label: t('Activity Date'), className: 'activityDate' },
    ];

    const renderRow = (activity) => (
        <tr key={activity._id} onClick={() => handleRowClick(activity)} className={styles.tablePointer}>
            <td>{truncateText(activity?.activityName)}</td>
            <td>{truncateText(activity?.subject)}</td>
            <td>{truncateText(activity?.remarks)}</td>
            <td>{formatDateFromDB(activity?.date)}</td>
        </tr>
    );

    const handleShowModal = () => {
        setNewActivity({
            activityName: '',
            subject: '',
            remarks: '',
            date: new Date(),
            remaindTimeMin: 0
        });
        setIsEditMode(false);
        setActivitiyShowModal(true);
    };
    const handleCloseModal = () => setActivitiyShowModal(false);

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setNewActivity(prevState => ({
    //         ...prevState,
    //         [name]: value
    //     }));
    // };

    const handleInputChange = (selectedDates, dateStr, instance) => {
        if (Array.isArray(selectedDates) && selectedDates[0]) {
            setNewActivity(prevState => ({
                ...prevState,
                date: selectedDates[0].toISOString()
            }));
        } else if (instance) {
            const { name, value } = instance.input;
            setNewActivity(prevState => ({
                ...prevState,
                [name]: value
            }));
        } else {
            const { name, value } = selectedDates.target;
            setNewActivity(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const saveNewActivity = async (e) => {
        e.preventDefault();
        // console.log('Saving new activity:', newActivity);

        const contactId = props.nowSelectedContact?._id || props.selectedConv?.contactId?._id || props.callSelected?.callObj?.contactId?._id || props.dialItemSelected?.dialListObj?.contactId?._id;
        if (!contactId) {
            alertCtx.showAlert(t('fail'), t('No contactId available for saving the new activity'), 'sm')
            return;
        }

        let response;
        if (isEditMode) {
            response = await editActivity(newActivity._id, newActivity);
        } else {
            response = await createActivity(contactId, newActivity);
        }

        if (response.error) {
            console.error('Failed to save activity:', response.error);
            alertCtx.showAlert(t('fail'), t('Activity Name and Activity Subject is must'), 'sm')
        } else {
            // console.log('Activity saved successfully:', response);
            setRefreshActivities(prev => !prev);
            setNewActivity({
                activityName: '',
                subject: '',
                remarks: '',
                date: new Date(),
                remaindTimeMin: 0
            });
            alertCtx.showAlert(t('success'), isEditMode ? t('The activity has been updated') : t('The record has been added to the activity'), 'sm');
            handleCloseModal();
        }

    };


    const deleteActivityHandler = async (activityId) => {
        const response = await deleteActivity(activityId);
        if (response.error) {
            console.error('Failed to create activity:', response.error);
        } else {
            console.log('Activity created successfully:', response);
            setRefreshActivities(prev => !prev);
            setNewActivity({})
            alertCtx.showAlert(t('success'), t('The record has been successfully deleted'), 'sm');
        }
        handleCloseModal();
    };

    useEffect(() => {
        const fetchAllActivitys = async () => {
            if ((props.contactListMode === 'edit' && props.nowSelectedContact && props.whereTypped === 'CONTACT') ||
                (props.contactListMode === 'edit' && props.selectedConv && props.whereTypped === 'CONV') ||
                (props.contactListMode === 'edit' && props.callSelected && props.whereTypped === 'DIALER') ||
                (props.contactListMode === 'edit' && props.dialItemSelected && props.whereTypped === 'DIALLIST')) {
                let response = await getAllActivitys();

                if (response && response.status === "success") {
                    let responseData = response.data.data;
                    if (Array.isArray(responseData) && props.whereTypped === 'CONTACT') {
                        responseData = responseData.filter(activity => activity.contactId === props.nowSelectedContact?._id);
                        setActivities(responseData);
                    }
                    else if (Array.isArray(responseData) && props.whereTypped === 'CONV') {
                        responseData = responseData.filter((activity) => activity.contactId === props.selectedConv?.contactId?._id)
                        setActivities(responseData);
                    }
                    else if (Array.isArray(responseData) && props.whereTypped === 'DIALER') {
                        responseData = responseData.filter((activity) => activity.contactId === props.callSelected?.callObj?.contactId?._id)
                        setActivities(responseData)
                    }
                    else if (Array.isArray(responseData) && props.whereTypped === 'DIALLIST') {
                        responseData = responseData.filter((activity) => activity.contactId === props.dialItemSelected?.dialListObj?.contactId?._id)
                        setActivities(responseData)
                    } else {
                        console.error('Expected an array but received:', responseData);
                        setActivities([]);
                    }
                } else {
                    setActivities([]);
                }
            }
        };
        fetchAllActivitys();
    }, [props.nowSelectedContact, props.contactListMode, props.whereTypped, props.selectedConv, props.callSelected, props.dialItemSelected, refreshActivities]);

    const truncateText = (text, maxLength = 35) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substr(0, maxLength) + '...';
    }

    const handleRowClick = (activity) => {
        setNewActivity({
            ...activity,
            // date: new Date(activity.date)
            date: activity.date ? new Date(activity.date) : new Date()
        });
        // Show the modal
        setActivitiyShowModal(true);
        setIsEditMode(!!activity._id);
    };

    // console.log(`Activities: ${activities.length}, Current Page: ${currentPage}, Items Per Page: ${itemsPerPage}`);

    return (
        <>
            <Button className={`${styles.activityBtn} btn-success`} variant="primary" onClick={handleShowModal}>
                {t('Insert New Activity')}
            </Button>
            <Grid
                headers={headers}
                data={currentActivities}
                renderRow={renderRow}
                itemsPerPage={itemsPerPage}
                totalItems={activities.length}
                paginate={paginate}
                currentPage={currentPage}
                headerStyles={styles}
            />

            <ActivityModal
                showActivityModal={showActivityModal}
                handleCloseModal={handleCloseModal}
                newActivity={newActivity}
                handleInputChange={handleInputChange}
                saveNewActivity={saveNewActivity}
                className="modal-custom-size"
                onDeleteActivity={deleteActivityHandler}
                isEditMode={isEditMode}
            />
        </>
    );
}

export default ActivityContact;